import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./stockOrdered.module.scss";

const StockOrdered = () => {
  const { t } = useTranslation();

  return (
    <Pill
      styleName="stockOrdered"
      Lefticon={<img src="../../../assets/images/svg/stock.svg" />}>
      <p className={classNames(styles.stockText, "p2")}>
        {t("lbl_out_of_stock")}
      </p>
    </Pill>
  );
};

export default StockOrdered;
